import {createContext} from 'react';

export const CloseBookingContext = createContext<undefined | null |(() => void)>(null);
